import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { GridModule } from '../grid/grid.module';
import { PriceboostCountSignpostComponent } from '../shared-priceboost/Components/priceboost-count-signpost.component';
import { PriceBoostComponent } from './components/price-boost.component';

@NgModule({
    imports: [CommonModule, GridModule, FormsModule, PriceboostCountSignpostComponent],
    declarations: [PriceBoostComponent],
    exports: [PriceBoostComponent],
})
export class PriceBoostModule {}
